import { useSelector } from '@xstate/react';
import { UserContext } from '~/app';
import { ContractsSummaryCard } from '~/features/market/contracts/components/ContractsSummaryCard';
import { JobListingsSection } from './cards/JobListingsSection';
import { UpcomingCalendarCard } from './cards/UpcomingCalendarCard';

export const EmployerDashboard = () => {
  const marketRef = UserContext.useSelector((state) => state.context.marketRef);
  const employerUser = useSelector(marketRef, (state) => state?.context?.employerUser);
  const employerId = employerUser?.employerId?.toString() ?? '';

  return (
    <div className="flex flex-col gap-4">
      <UpcomingCalendarCard />
      <JobListingsSection employerId={employerId} />
      <ContractsSummaryCard />
    </div>
  );
};
